import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

class JobPostParser {
  async parseJobPost(fullJobPost) {
    try {
      const parseJobPost = httpsCallable(functions, 'parseJobPost');
      const result = await parseJobPost({ fullJobPost });
      
      if (result.data.success) {
        return result.data.data;
      } else {
        throw new Error(result.data.error || 'Failed to parse job post');
      }
    } catch (error) {
      console.error('Error parsing job post:', error);
      return null; // ✅ Your original fallback
    }
  }
}

export default new JobPostParser();